<template>
	<div class="wrapper">
		<v-icon @click="closeModal" class="closeButton" color="#000"
			>close</v-icon
		>
		<img
			class="giftImage"
			src="https://cdn.jeet11.com/images/retail-tool-assets/gift3.jpeg"
		/>
		<div class="centerContainer">
			<div class="bigText">₹ {{ gmvPerDay }}</div>
			<div class="subText">
				GMV per DAY
			</div>
		</div>
		<div class="inputContainer">
			<div class="subText">
				Check Prize
			</div>
			<v-select
				:items="TSM_QUARTERLY_TARGETS"
				label="Target Ranges"
				v-model="selectedRange"
				return-object
				class="mt-3"
				color="#000"
			>
				<template slot="selection" slot-scope="data">
					<div style="color: #000">
						₹ {{ data.item.lower.toLocaleString("hi") }}
						{{
							data.item.upper === 200000000000
								? "and above"
								: `to ₹ ${data.item.upper.toLocaleString("hi")}`
						}}
					</div>
				</template>
				<template slot="item" slot-scope="data">
					<div style="color: #000">
						₹ {{ data.item.lower.toLocaleString("hi") }}
						{{
							data.item.upper === 200000000000
								? "and above"
								: `to ₹ ${data.item.upper.toLocaleString("hi")}`
						}}
					</div>
				</template>
			</v-select>
		</div>
		<div class="winningItemContainer">
			<div
				v-for="(item, index) in Object.keys(prizeDetails)"
				:key="index"
			>
				<div class="marginText">{{ item }}</div>
				<div v-for="(item, index) in prizeDetails[item]" :key="index">
					<div class="itemContainer">
						<div>
							<img :src="item.image" />
						</div>
						<div>
							<div class="mediumText">{{ item.title }}</div>
							<div
								@click="openLink(item.link, item.title)"
								class="smallLink"
							>
								View Prize
							</div>
						</div>
					</div>
					<div
						class="plusSign"
						v-if="index < prizeDetails.length - 1"
					>
						+
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import EventsManager from "@/event-manager";
import { TSM_QUARTERLY_TARGETS } from "../constants";
export default {
	props: ["gmvPerDay"],
	data() {
		return {
			prizeDetails: [],
			selectedRange: {},
			TSM_QUARTERLY_TARGETS: TSM_QUARTERLY_TARGETS
		};
	},
	methods: {
		closeModal() {
			this.prizeDetails = [];
			this.selectedRange = {};
			this.$emit("CLOSE_MODAL");
		},
		openLink(link, title) {
			EventsManager.sendEvent({
				name: "TSM_QUARTER_TARGET_VIEW_PRIZE_CLICKED",
				properties: {
					userId: this.retailerId,
					prize: title
				}
			});
			window.open(link, "_blank");
		},
		setSelectedRange() {
			let selectedIndex = -1;
			this.TSM_QUARTERLY_TARGETS.every((element, index) => {
				if (
					this.gmvPerDay >= element.lower &&
					this.gmvPerDay <= element.upper
				) {
					selectedIndex = index;
					return false;
				}
				return true;
			});
			if (selectedIndex > -1) {
				this.selectedRange = this.TSM_QUARTERLY_TARGETS[selectedIndex];
			}
		}
	},
	mounted() {
		this.setSelectedRange();
	},
	watch: {
		selectedRange(newVal) {
			EventsManager.sendEvent({
				name: "TSM_QUARTER_TARGET_RANGE_SELECTED",
				properties: {
					userId: this.retailerId,
					minValue: newVal.lower
				}
			});
			this.prizeDetails = newVal.items;
		}
	}
};
</script>

<style scoped lang="scss">
.wrapper {
	background: white;
	background-image: url("https://cdn.jeet11.com/images/retail-tool-assets/targetBg3.png");
	display: flex;
	flex-direction: column;
	position: relative;
	padding: 24px;
	align-items: center;
	background-repeat: no-repeat;
	background-position: center;
	background-size: cover;
	min-height: 100%;
}
.closeButton {
	position: absolute;
	top: 8px;
	right: 8px;
}
.giftImage {
	margin: 20px;
}
.centerContainer {
	margin: 36px 0;
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
}
.subText {
	text-transform: uppercase;
	color: rgba(0, 0, 0, 0.8);
	font-weight: 500;
}
.bigText {
	text-transform: uppercase;
	color: rgba(0, 0, 0, 1);
	font-weight: 600;
	font-size: 36px;
}
.marginText {
	font-size: 18px;
	font-weight: 600;
}
.mediumText {
	text-transform: uppercase;
	color: rgba(0, 0, 0, 1);
	font-size: 14px;
	text-align: center;
}
.inputContainer {
	display: flex;
	flex-direction: column;
	justify-content: center;
	text-align: center;
	width: 75%;
}
.buttonContainer {
	width: 75%;
}
.customButton {
	padding: 12px;
	border-radius: 12px;
	background-color: #42378f;
	background-image: linear-gradient(315deg, #42378f 0%, #f53844 74%);
	color: #fff;
	font-size: 16px;
	width: 100%;
	margin: 8px 0;
	text-align: center;
}
.itemContainer {
	margin-top: 20px;
	margin-bottom: 20px;
	display: flex;
	align-items: center;
	border: 1px solid #000;
	padding: 8px;
	border-radius: 8px;
	& > div:first-child {
		width: 35%;
	}
	& > div:last-child {
		width: 65%;
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 0 8px;
	}
}
.smallLink {
	text-align: center;
	text-decoration: underline;
	cursor: pointer;
	color: #000;
	width: 50%;
	margin-top: 12px;
}
.plusSign {
	text-align: center;
	color: #000;
	font-size: 22px;
	line-height: 0;
}
</style>
